// extracted by mini-css-extract-plugin
export default {"label":"Yp7lNwAtVRpB2WUnqNz7","action_link":"__KLFrtlkFySo54JWzXQ","input_text":"YHjN_iSaiGzai7pj1vq9"};